import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';

import TituloSessao from '../componentes/TituloSessao';
import TelaInformativa from './TelaInformativa';
import SelectMetricaIndicadorControlled from '../componentes/SelectMetricaIndicadorControlled';
import { CONSTANTES } from '../util/constantes'

import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { servReciboEnvioIndicadoresMes, servDownloadFilePorFilename } from '../servicos/servicosEmRotasPrivadas/download';
import { servBuscarIndicadorParaEdicao, servPostIndicadorLote } from '../servicos/servicosEmRotasPrivadas/indicador';
import DataMesControlled from '../componentes/DataMesControlled';
import BarraBuscaComTodasUnidades from '../componentes/BarraBuscaComTodasUnidades';

function AjustarIndicadores() {

    console.log('### Iniciando AjustarIndicadores ###');


    const [indicador, setIndicador] = useState(null);
    const [query, setQuery] = useState({
        mesReferencia: null,
        estabelecimentoId: null,
        metricaId: null
    })

    console.log(indicador);

    useEffect(() => {
        console.log('Executando use effect');
        console.log(query);
        if (query.mesReferencia && query.estabelecimentoId && query.metricaId) {
            buscarIndicadorParaEdicao()
        }
    }, [query]);

    const buscarIndicadorParaEdicao = async () => {

        try {
            const response = await servBuscarIndicadorParaEdicao(query)
            setIndicador(response.data[0]);
        } catch (error) {
            console.error(error);
        }
    }

    function updateFiltro(nome, valor) {
        console.log('Atualizando filtros');
        console.log(nome);
        console.log(valor);
        
        setQuery(prev => ({
            ...prev,
            [nome]: valor
        }))
    }

    return (
        <div className='d-flex flex-column container'>
            <TituloSessao titulo='Ajustar Indicadores' barraDecorativa={false} centralizaTitulo={true} />
            <div className='div-com-borda d-flex flex-column gap-3 p-3 mb-3'>
                <div className='d-flex row gap-3'>
                    <div className='col-3'>
                        <label className='text-nowrap' htmlFor='mes-competencia'>Mês de Competência</label>
                        <DataMesControlled
                            id='mes-competencia'
                            mes={query.mesReferencia}
                            onChange={(v) => updateFiltro("mesReferencia", v)}
                            getUltimoDia={false}
                        />
                    </div>
                    <div className='col-8'>
                        <label className='text-nowrap' htmlFor='select-metrica-indicador'>Indicador</label>
                        <SelectMetricaIndicadorControlled
                            id='select-metrica-indicador'
                            value={query.metricaId}
                            onChange={(v) => updateFiltro("metricaId", v)}
                        />
                    </div>
                </div>
                <div>
                    <BarraBuscaComTodasUnidades
                        id='barra-busca-estabelecimento'
                        setEstabelecimento={(estabelecimento) => updateFiltro("estabelecimentoId", estabelecimento ? estabelecimento.id : null)}
                        somenteAtivos={true}
                        enviaRelatorioAcompanhamento={false}
                    />
                </div>
            </div>
            {/* <button
                className="btn btn-primary mt-2"
                type="button"
                onClick={() => buscarIndicadorParaEdicao()}
            >BUSCAR
            </button> */}
            {indicador &&
                <form className='d-flex flex-column div-com-borda gap-3 p-3 mt-3'>
                    <div className='d-flex gap-3'>
                        <div className='col-3'>
                            <label htmlFor='form-label input-numerador'>Numerador</label>
                            <input
                                className='form-control'
                                id='input-numerador'
                                value={indicador.numerador}
                                type='number'
                                onChange={(e) => setIndicador(prev => ({
                                    ...prev,
                                    numerador: e.target.value
                                }))}
                            />
                        </div>
                        <div className='col-3'>
                            <label htmlFor='form-label input-denominador'>Denominador</label>
                            <input
                                className='form-control'
                                id='input-denominador'
                                value={indicador.denominador}
                                type='number'
                                onChange={(e) => setIndicador(prev => ({
                                    ...prev,
                                    denominador: e.target.value
                                }))}
                            />
                        </div>
                    </div>
                    <div className=''>
                        <label htmlFor='form-label col-6 input-justificativa'>Justificativa</label>
                        <textarea
                            className='form-control'
                            id='input-justificativa'
                            value={indicador.justificativa || ''}
                            type='text'
                            onChange={(e) => setIndicador(prev => ({
                                ...prev,
                                justificativa: e.target.value
                            }))}
                        />
                    </div>
                    <p>Resultado atual: {indicador.resultado ? Number(indicador.resultado).toFixed(2) : ""} </p>
                </form>}
            <button
                className="btn btn-primary mt-2"
                type="button"
                onClick={() => buscarIndicadorParaEdicao()}
            >GRAVAR
            </button>
        </div>
    );
}

export default AjustarIndicadores
